import React from 'react';
import { Helmet } from 'react-helmet';
import { BASE_URL } from '../constants/strings';

const DEFAULT_IMAGE = `${BASE_URL}/logo512.png`;

/**
 * Renders per-page Open Graph + Twitter Card tags. Because the static index.html
 * no longer carries homepage-specific og:* tags, every public page sets its own
 * here, and react-snap bakes them into the prerendered HTML so social scrapers
 * and AI crawlers (which don't run JS) get the correct per-page preview.
 *
 * `url` may be absolute or a root-relative path ("/produkter").
 */
const SeoMeta = ({ title, description, url, image, type = 'website' }) => {
  const absoluteUrl = url
    ? (url.startsWith('http') ? url : `${BASE_URL}${url}`)
    : BASE_URL;
  const img = image
    ? (image.startsWith('http') ? image : `${BASE_URL}${image}`)
    : DEFAULT_IMAGE;

  return (
    <Helmet>
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SeoMeta;
